<div class="card" style="width:100%;" id="InsuredInfo">
  <ul class="nav nav-tabs listdata" role="tablist">
    <li role="presentation" class="active">
      <a href="#home" aria-controls="home" role="tab" data-toggle="tab">{{'Insured Info'| translate }}</a>
    </li>

  </ul>
  <div class="tab-content detailsTab">
    <div role="tabpanel" class="tab-pane active" id="home">

      <!-- <div class="InsuredForm" *ngIf="!DriverRequired && !ReviewInfo">-->
      <div class="InsuredForm">
        <form #insuredForm="ngForm">
          <div class="Field">
            <div class="row">
              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                <label class="lbltext">{{ 'Insured Name as per Passport' | translate }}</label>
                <input type="text" class="form-control" required id="txtName" name="txtName" required [(ngModel)]="prObj.Insured_Name" pattern="[a-zA-Z ]*$" #txtName="ngModel" autocomplete="off" />
                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="Insured Name Required"></span>
                <span *ngIf="txtName.invalid && (txtName.dirty || isSubmitted)" class="text-danger">
                  <div *ngIf="txtName.errors.required">
                    {{'Insured Name is required' | translate }}.
                  </div>
                  <div *ngIf="txtName.errors?.pattern">
                    {{'Insured Name must Be In English'| translate }}
                  </div>
                </span>

                <!-- <i class="fa fa-question-circle" class="popoeverstyle"  data-toggle="popover"  data-content="Default popover"></i> -->
                <!-- <label class="popoeverstyle"  data-toggle="popover"  data-content="Default popover">ss</label> -->
              </div>
              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                <label class="lbltext">{{'Gender' | translate }}</label>

                <select class="form-control" required name="txtGender" id="txtGender" [(ngModel)]="prObj.Gender" [disabled]="true" #txtGender="ngModel" autocomplete="off">
                  <option value="">--{{'Select Gender'| translate }} --</option>
                  <option *ngFor="let gen of travelBindObj.genderList" [value]="gen.GenderCode">
                    {{ Lng=="en"? gen.GenderDescEn : gen.GenderDescAr }}</option>
                </select>
                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="Gender Required"></span>
                <span *ngIf="txtGender.invalid && (txtGender.dirty || isSubmitted)" class="text-danger">
                  <div *ngIf="txtGender.errors.required">
                    {{'Gender is required' | translate }}.
                  </div>
                </span>
              </div>

              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                <label class="lbltext">{{'Date of birth' | translate }}</label>
                <input type="text" class="form-control" required name="txtDOB" id="txtDOB" [(ngModel)]="prObj.IDOBStr" [disabled]="true" #txtDOB="ngModel" autocomplete="off" />
                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="DOB Required"></span>
                <span *ngIf="txtDOB.invalid && (txtDOB.dirty || isSubmitted)" class="text-danger">
                  <div *ngIf="txtDOB.errors.required">
                    {{'DOB is required'|translate}}
                  </div>
                </span>
              </div>




              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                <label class="lbltext">{{'Date of birth(Hijri)'| translate }}</label>
                <input type="text" class="form-control" required name="txtDOBHijri" id="txtDOBHijri" [(ngModel)]="prObj.HDOB" [disabled]="true" #txtDOBHijri="ngModel" autocomplete="off" />
                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="DOB Hijri Required"></span>
                <span *ngIf="txtDOBHijri.invalid && (txtDOBHijri.dirty || isSubmitted)" class="text-danger">
                  <div *ngIf="txtDOBHijri.errors.required">
                    {{'DOB Hijri is required'| translate }}
                  </div>
                </span>
              </div>

            </div>



          </div>





          <div class="Field">
            <div class="row">
              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                <label class="lbltext">{{'Passport Number'| translate }}</label>
                <input type="text" class="form-control" required id="txtPassportNo" name="txtPassportNo" required [(ngModel)]="prObj.IPassportNo" [disabled]="false" #txtPassportNo="ngModel" pattern="[0-9a-zA-Z]*$" autocomplete="off" maxlength="30" />
                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="Passport No is Required"></span>
                <span *ngIf="txtPassportNo.invalid && (txtPassportNo.dirty || isSubmitted)" class="text-danger valid">
                  <div *ngIf="txtPassportNo.errors.required">
                    {{'Passport No is required'| translate }}
                  </div>

                  <div *ngIf="txtPassportNo.errors?.pattern">
                    {{'PassportNo must Contain Only AlphaNumerics'| translate }}
                  </div>
                  <div *ngIf="txtPassportNo.errors?.maxlength">
                    {{'PassportNo Can Have Maximum 30 Characters'| translate }}
                  </div>
                </span>

                <!-- <i class="fa fa-question-circle" class="popoeverstyle"  data-toggle="popover"  data-content="Default popover"></i> -->
                <!-- <label class="popoeverstyle"  data-toggle="popover"  data-content="Default popover">ss</label> -->
              </div>
              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                <label class="lbltext">{{'Place Of Birth'| translate }}</label>

                <select class="form-control" required name="txtPlaceOfBirth" id="txtPlaceOfBirth" [(ngModel)]="prObj.PlaceOfBirth" [disabled]="false" #txtPlaceOfBirth="ngModel" autocomplete="off">
                  <option value="">--{{'Place of Birth'| translate }}--</option>
                  <option *ngFor="let nat of travelBindObj.natList" [value]="nat.NATCode">
                    {{ Lng=="en"? nat.CountryNameEn : nat.CountryNameAr }}</option>
                </select>
                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="Gender Required"></span>
                <span *ngIf="txtPlaceOfBirth.invalid && (txtPlaceOfBirth.dirty || isSubmitted)" class="text-danger valid">
                  <div *ngIf="txtPlaceOfBirth.errors.required">
                    {{'PlaceOfBirth is required'| translate }}
                  </div>
                </span>
              </div>

              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                <label class="lbltext">{{'Nationality'| translate }}* </label>
                <select class="form-control" required name="txtNat" id="txtNat" [(ngModel)]="prObj.Insured_Nationality" [disabled]="prObj.Insured_NationalityExists" #txtNat="ngModel" autocomplete="off">
                  <option value="">--{{'Nationality'| translate }}--</option>
                  <option *ngFor="let nat of travelBindObj.natList" [value]="nat.NATCode">
                    {{ Lng=="en"? nat.NATNameEn : nat.NATNameAr }}</option>
                </select>
                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="Insured Nationality is  Required"></span>
                <span *ngIf="txtNat.invalid && (txtNat.dirty || isSubmitted)" class="text-danger valid">
                  <div *ngIf="txtNat.errors.required">
                    {{'Nationality is required'| translate }}
                  </div>
                </span>
              </div>




              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                <label class="lbltext">{{'Occupation'| translate }}*</label>
                <select class="form-control" required name="txtOccu" id="txtOccu" [(ngModel)]="prObj.IOccupation" #txtOccu="ngModel" autocomplete="off">
                  <option value="">--{{'Occupation'|translate}}--</option>
                  <option *ngFor="let nat of travelBindObj.occList" [value]="nat.OccuCode">
                    {{ Lng=="en"? nat.OccuDescEn : nat.OccuDescAr }}</option>
                </select>


                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content=" Occupation is required."></span>
                <span *ngIf="txtOccu.invalid && (txtOccu.dirty || isSubmitted)" class="text-danger valid">
                  <div *ngIf="txtOccu.errors.required">
                    {{'Occupation is required'| translate }}
                  </div>
                </span>
              </div>

            </div>

          </div>


          <div class="Field">
            <div class="row">
              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                <label class="lbltext">{{'City'| translate }}</label>
                <select class="form-control" id="txtCity" required name="txtCity" [(ngModel)]="prObj.ICity" [disabled]="prObj.cityExists" #txtCity="ngModel" autocomplete="off">
                  <option value="">---{{'Select City'| translate }}--</option>
                  <option *ngFor="let cty of travelBindObj.cityList" [value]="cty.CityCode">
                    {{ Lng=="en"? cty.CityNameEn:cty.CityNameAr }}</option>
                </select>
                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="City Required"></span>
                <span *ngIf="txtCity.invalid && (txtCity.dirty || txtCity.touched || isSubmitted)" class="text-danger valid">
                  <div *ngIf="txtCity.errors?.required">
                    {{'City is required'| translate }}
                  </div>
                </span>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6">
                <label class="lbltext">{{'Building No'| translate }}</label>
                <input type="text" class="form-control" required numbersOnly name="txtBuildingNumber" id="txtBuildingNumber" [(ngModel)]="prObj.Insured_BuildingNo" [disabled]="prObj.buildingNumberExists" #txtBuildingNumber="ngModel" minlength="4" maxlength="4" pattern="^[1-9]\d*$" autocomplete="off" />
                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="Building No Required"></span>
                <span *ngIf="txtBuildingNumber.invalid && (txtBuildingNumber.dirty || txtBuildingNumber.touched || isSubmitted)" class="text-danger valid">
                  <div *ngIf="txtBuildingNumber.errors?.required">
                    {{'BuildingNumber is required'| translate }}
                  </div>
                  <div *ngIf="txtBuildingNumber.errors?.pattern">
                    {{'BuildingNumber must Allow Only Numerics and Should Not start with Zero'| translate }}
                  </div>

                  <div *ngIf="txtBuildingNumber.errors?.minlength">
                    {{'BuildingNumber must be 4 digits'| translate }}
                  </div>
                  <div *ngIf="txtBuildingNumber.errors?.maxlength">
                    {{'BuildingNumber must be 4 digits'| translate }}
                  </div>
                </span>
              </div>

              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6">
                <label class="lbltext">{{'Additional Code'| translate }}</label>
                <input type="text" class="form-control" required numbersOnly name="txtAdditionalNumber" id="txtAdditionalNumber" [(ngModel)]="prObj.Insured_AdditionalCode" [disabled]="prObj.additionalNumberExists" #txtAdditionalNumber="ngModel" minlength="4" maxlength="4" pattern="^[1-9]\d*$" autocomplete="off" />
                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="Default popover"></span>
                <span *ngIf="txtAdditionalNumber.invalid && (txtAdditionalNumber.dirty || txtAdditionalNumber.touched || isSubmitted)" class="text-danger valid">
                  <div *ngIf="txtAdditionalNumber.errors?.required">
                    {{'AdditionalNumber is required'| translate }}
                  </div>
                  <div *ngIf="txtAdditionalNumber.errors?.pattern">
                    {{'AdditionalNumber must Allow Only Numerics and Should Not start with Zero'| translate }}
                  </div>

                  <div *ngIf="txtAdditionalNumber.errors?.minlength">
                    {{'AdditionalNumber must be 4 digits'| translate }}
                  </div>
                  <div *ngIf="txtAdditionalNumber.errors?.maxlength">
                    {{'AdditionalNumber must be 4 digits'| translate }}
                  </div>
                </span>
              </div>




              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                <label class="lbltext">{{'Street Name'| translate }}</label>
                <input type="text" class="form-control" required name="txtStreetName" id="txtStreetName" [(ngModel)]="prObj.Insured_StreetName" [disabled]="prObj.streetNameExists" #txtStreetName="ngModel" autocomplete="off" />
                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="Street Required"></span>
                <span *ngIf="txtStreetName.invalid && (txtStreetName.dirty || txtStreetName.touched || isSubmitted)" class="text-danger valid">
                  <div *ngIf="txtStreetName.errors.required">
                    {{'StreetName is required'| translate }}
                  </div>
                </span>
              </div>

            </div>

          </div>



          <div class="Field">
            <div class="row">
              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                <label class="lbltext">{{'District Name'| translate }}</label>
                <input type="text" class="form-control" required name="txtDistName" id="txtDistName" [(ngModel)]="prObj.Insured_DistName" [disabled]="prObj.districtExists" #txtDistName="ngModel" autocomplete="off" />
                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="District Required"></span>
                <span *ngIf="txtDistName.invalid && (txtDistName.dirty || txtDistName.touched || isSubmitted)" class="text-danger valid">
                  <div *ngIf="txtDistName.errors.required">
                    {{'District Name is required'| translate }}
                  </div>
                </span>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                <label class="lbltext">{{'Postal Code'| translate }}</label>
                <input type="text" class="form-control" required name="txtPostalCode" id="txtPostalCode" [(ngModel)]="prObj.Insured_POPostalCode" [disabled]="prObj.postCodeExists" #txtPostalCode="ngModel" minlength="5" maxlength="5" pattern="^[1-9]\d*$" autocomplete="off" />
                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="Postl Code Required"></span>
                <span *ngIf="txtPostalCode.invalid && (txtPostalCode.dirty || txtPostalCode.touched || isSubmitted)" class="text-danger valid">
                  <div *ngIf="txtPostalCode.errors?.required">
                    {{'PostalCode is required'| translate }}
                  </div>
                  <div *ngIf="txtPostalCode.errors?.pattern">
                    {{'PostalCode must Allow Only Numerics and Should Not start with Zero'| translate }}
                  </div>

                  <div *ngIf="txtPostalCode.errors?.minlength">
                    {{'PostalCode must be 5 digits'| translate }}
                  </div>
                  <div *ngIf="txtPostalCode.errors?.maxlength">
                    {{'PostalCode must be 5 digits'| translate }}
                  </div>
                </span>

              </div>

              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                <label class="lbltext">{{'Address Type'| translate }}</label>
                <select class="form-control" id="txtAddessType" name="txtAddressType" required [(ngModel)]="prObj.AddressType" #txtAddressType="ngModel" autocomplete="off">
                  <option value="">--{{'Select Address Type'| translate }}--</option>
                  <option value="WaselAddress">{{'Wasel Address'| translate }}</option>
                  <option value="PostalAddress">{{'Postal Address'| translate }}</option>
                </select>
                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="Address Type Required"></span>
                <span *ngIf="txtAddressType.invalid && (txtAddressType.dirty || isSubmitted || txtAddressType.touched)" class="text-danger valid">
                  <div *ngIf="txtAddressType.errors.required">
                    {{'Address Type is required'| translate }}
                  </div>

                </span>
              </div>




              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12" *ngIf="prObj.AddressType=='PostalAddress'">
                <label class="lbltext">{{'Post BoxNo'| translate }}</label>
                <input type="text" class="form-control" [required]="prObj.AddressType=='PostalAddress'" name="txtPBox" id="txtPBox" [(ngModel)]="prObj.IPoBoxNo" #txtPBox="ngModel" minlength="1" maxlength="6" pattern="^[1-9]\d*$" autocomplete="off" />
                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="Postal Required"></span>
                <span *ngIf="txtPBox.invalid && (txtPBox.dirty || isSubmitted || txtPBox.touched)" class="text-danger valid">
                  <div *ngIf="txtPBox.errors?.required">
                    {{'Post BoxNo is required'| translate }}
                  </div>

                  <div *ngIf="txtPBox.errors?.pattern">
                    {{'Post BoxNo must Contain Only Numerics and Should Not start with 0'| translate }}
                  </div>

                  <div *ngIf="txtPBox.errors?.minlength">
                    {{'Post BoxNo should Have minimum 1 digit'| translate }}
                  </div>
                  <div *ngIf="txtPBox.errors?.maxlength">
                    {{'Post BoxNo Can Have maximum 6 digits'| translate }}
                  </div>


                </span>
              </div>

            </div>

          </div>
          <div class="Field">
            <div class="row">
              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12" *ngIf="this.prObj.Insured_Nationality=='17'">
                <label class="lbltext">{{'American ID'| translate }}</label>
                <input class="form-control" id="txtamericanID" name="txtamericanID" minlength="4" maxlength="15" required (keypress)="ValidateSpecialChar($event)" [(ngModel)]="prObj.AmericanID" #txtamericanID="ngModel">
                <span *ngIf="txtamericanID.invalid && (txtamericanID.dirty || txtamericanID.touched || isSubmitted)" class="text-danger valid">
                  <div *ngIf="txtamericanID.errors?.required">
                    {{'American ID is required'| translate }}</div>
                  <div *ngIf="txtamericanID.errors?.minlength">
                    {{'American ID must be atleast 3 digits' | translate}}</div>
                  <div *ngIf="txtamericanID.errors?.maxlength">
                    {{'American ID must be maximum 15 digits' | translate}}</div>
                </span>
              </div>
            </div>
          </div>

          <div class="row iban">
            <div class="col-lg-8 col-sm-12 col-xs-12" style="padding: 0px 24px;">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label class="lbltext" style="margin: 0px -14px;">{{'IBAN Number'| translate }}</label>
                <div class="row">

                  <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                    <div class="input-group groupItems">
                      <div class="input-group-addon">SA</div>
                      <input type="text" class="form-control" id="txtIBAN1" name="txtIBAN1" [(ngModel)]="prObj.IBAN1" maxlength="2" #txtIBAN1 [value]="txtIBAN1.value.toUpperCase()" (ngModelChange)="iban1Changed($event)" required autocomplete="off" />
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                    <input type="text" class="form-control" id="txtIBAN2" name="txtIBAN2" [(ngModel)]="prObj.IBAN2" maxlength="4" (blur)="setBankCode(prObj.IBAN2)" [disabled]="prObj.IBAN1?.length!=2" #txtIBAN2 [value]="txtIBAN2.value.toUpperCase()" (ngModelChange)="iban2Changed($event)" numbersOnly required autocomplete="off" />
                  </div>
                  <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                    <input type="text" class="form-control" id="txtIBAN3" name="txtIBAN3" [(ngModel)]="prObj.IBAN3" maxlength="4" [disabled]="prObj.IBAN2?.length!=4" #txtIBAN3 [value]="txtIBAN3.value.toUpperCase()" (ngModelChange)="iban3Changed($event)" numbersOnly required autocomplete="off" />
                  </div>
                  <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                    <input type="text" class="form-control" id="txtIBAN4" name="txtIBAN4" [(ngModel)]="prObj.IBAN4" maxlength="4" [disabled]="prObj.IBAN3?.length!=4" #txtIBAN4 [value]="txtIBAN4.value.toUpperCase()" (ngModelChange)="iban4Changed($event)" numbersOnly required autocomplete="off" />
                  </div>
                  <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                    <input type="text" class="form-control" id="txtIBAN5" name="txtIBAN5" [(ngModel)]="prObj.IBAN5" maxlength="4" [disabled]="prObj.IBAN4?.length!=4" #txtIBAN5 [value]="txtIBAN5.value.toUpperCase()" (ngModelChange)="iban5Changed($event)" numbersOnly required autocomplete="off" />
                  </div>
                  <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                    <input type="text" class="form-control" id="txtIBAN6" name="txtIBAN6" [(ngModel)]="prObj.IBAN6" maxlength="4" [disabled]="prObj.IBAN5?.length!=4" #txtIBAN6 [value]="txtIBAN6.value.toUpperCase()" numbersOnly required autocomplete="off" />
                  </div>

                </div>
              </div>

              <span class="text-danger valid">*{{'IBAN Number must start with SA and enter 4 digits in each textbox(Ex:SA12 8056 7890 1234 6575 9898)'|translate}}</span>
            </div>

            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
              <label class="lbltext">{{'Bank Name'| translate }}</label>
              <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="Required"></span>
              <select class="form-control" id="txtBankName" name="txtBankName" [(ngModel)]="prObj.BankCode" [disabled]="true">
                <option [value]="">--{{'Select Bank'| translate }}---</option>
                <option *ngFor="let bank of travelBindObj.bankList" [value]="bank.BankCode">
                  {{bank.BankDesc_Eng}}</option>
              </select>
            </div>


          </div>

          <div class="Field">
            <div class="row">
              <!-- <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                <label class="lbltext">{{'Bank Name'| translate }}</label>
                <select class="form-control" id="txtBankName" name="txtBankName" [(ngModel)]="prObj.BankCode" [disabled]="true">
                  <option [value]="">--{{'Select Bank'| translate }}---</option>
                  <option *ngFor="let bank of travelBindObj.bankList" [value]="bank.BankCode">
                    {{bank.BankDesc_Eng}}</option>
                </select>
              </div> -->

              <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                <label class="lbltext">{{ 'Are You Immune ?'| translate}}</label>
                <select class="form-control" id="txtIsVaccinated" name="txtIsVaccinated" required [(ngModel)]="prObj.IsVaccinated" (ngModelChange)="IsVaccinated(prObj.IsVaccinated)" #txtIsVaccinated="ngModel" autocomplete="off">
                  <option disabled value="">--{{'Select'| translate }}--</option>
                  <option value=true>{{'Yes'| translate }}</option>
                  <option value=false>{{'No'| translate }}</option>
                </select>
                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="Required"></span>
                <span *ngIf="txtIsVaccinated.invalid && (txtIsVaccinated.dirty || isSubmitted || txtIsVaccinated.touched)" class="text-danger valid">
                  <div *ngIf="txtIsVaccinated.errors.required">
                    {{'Required'| translate }}
                  </div>
                </span>
              </div>


              <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                <label class="lbltext">{{ 'Prefered Communication Type'| translate}}</label>
                <select class="form-control" id="txtPrefCommType" name="txtPrefCommType" required [(ngModel)]="prObj.PrefCommType" #txtPrefCommType="ngModel" autocomplete="off">
                  <option disabled value="">--{{'Select'| translate }}--</option>
                  <option value="SMS">{{'SMS'| translate }}</option>
                  <option value="EMAIL">{{'EMAIL'| translate }}</option>
                </select>
                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="Required"></span>
                <span *ngIf="txtPrefCommType.invalid && (txtPrefCommType.dirty || isSubmitted || txtPrefCommType.touched)" class="text-danger valid">
                  <div *ngIf="txtPrefCommType.errors.required">
                    {{'Required'| translate }}
                  </div>
                </span>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                <label class="lbltext">{{ 'Prefered Communication Language'| translate}}</label>
                <select class="form-control" id="txtPrefCommLng" name="txtPrefCommLng" required [(ngModel)]="prObj.PrefCommLng" #txtPrefCommLng="ngModel" autocomplete="off">
                  <option disabled value="">--{{'Select'| translate }}--</option>
                  <option value="E">{{'ENGLISH'| translate }}</option>
                  <option value="A">{{'ARABIC'| translate }}</option>
                </select>
                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="Required"></span>
                <span *ngIf="txtPrefCommLng.invalid && (txtPrefCommLng.dirty || isSubmitted || txtPrefCommLng.touched)" class="text-danger valid">
                  <div *ngIf="txtPrefCommLng.errors.required">
                    {{'Required'| translate }}
                  </div>
                </span>
              </div>

            </div>

            <div class="row" style="margin-top: 10px;">

              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <label class="lbltext">{{ 'Are you a political person or holding a high position in the government ?'| translate}}</label>
                <select class="form-control" id="txtIsHigherPosition" name="txtIsHigherPosition" required [(ngModel)]="prObj.IsHigherPosition" (ngModelChange)="IsHigherPosition(prObj.IsHigherPosition)" #txtIsHigherPosition="ngModel" autocomplete="off">
                  <option disabled value="">--{{'Select'| translate }}--</option>
                  <option value=true>{{'Yes'| translate }}</option>
                  <option value=false>{{'No'| translate }}</option>
                </select>
                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="Required"></span>
                <span *ngIf="txtIsHigherPosition.invalid && (txtIsHigherPosition.dirty || isSubmitted || txtIsHigherPosition.touched)" class="text-danger valid">
                  <div *ngIf="txtIsHigherPosition.errors.required">
                    {{'Required'| translate }}
                  </div>
                </span>
              </div>

              <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12" *ngIf="ShowHigherPositionFeild || prObj.IsHigherPosition">
                <label class="lbltext">{{ 'Higher Position'| translate}}</label>
                <select class="form-control" selectRequired id="txtHigherPosition" name="txtHigherPosition" [(ngModel)]="prObj.HigherPositionCode" #txtHigherPosition="ngModel">
                  <option value="0">{{'Select Higher Position' | translate}}</option>
                  <option value={{obj.PositionCode}} *ngFor="let obj of travelBindObj.highPosList">{{obj.Position_En}}</option>

                </select>
                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="modal" data-target="#HigherPosition" data-content="Click Me!"></span>
                <span *ngIf="txtHigherPosition.invalid && (txtHigherPosition.dirty || txtHigherPosition.touched || isSubmitted)" class="text-danger valid">
                  <span *ngIf="txtHigherPosition.errors?.selectRequired">{{'Higher Position is required.'|translate }}</span>
                </span>
              </div>

              <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                <label class="lbltext">{{ 'Assist'| translate}}</label>
                <input type="text" name="txtAssist" id="txtAssist" class="form-control" [(ngModel)]="prObj.ReferredBy" (keypress)="ValidateSpecialCharacters($event)" #txtAssist="ngModel">
              </div>

            </div>
          </div>


          <!-- Attachments Start -->
          <div class="row" style="margin-top: 20px;">
            <div class="col-md-6 col-lg-6 col-xs-12 col-sm-12">
              <div class="panel panel-default">
                <div class="panel-body">
                  <p class="text-center text-muted">
                    <i class="fa fa-camera fa-4x"></i>
                  </p>
                  <h4 class="text-center text-muted">{{ 'ID Copy' | translate }}
                    <small uib-tooltip="For New Arrivals">
                      <i class="fa fa-info-circle"></i>
                    </small>
                    <br>
                    <small>({{ 'Scan Copy' | translate}} )</small>
                  </h4>

                  <div style="position:relative;">
                    <a class="btn btn-block" href='javascript:;'>
                      <b style="color:whitesmoke;font-weight: 100;">{{ 'Choose File'| translate}}...</b>
                      <input class="choosefile" type="file" (change)="OnSelectIDCopy($event,passObj)" size="10" accept="image/*" />
                    </a>

                    <img *ngIf="passObj.IDCopy!=null" class="img-thumbnail imgdisplay" src="{{'data:image/jpg;base64,' + passObj.IDCopy}}" height="75px">

                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-lg-6 col-xs-12 col-sm-12">
              <div class="panel panel-default">

                <div class="panel-body">
                  <p class="text-center text-muted">
                    <i class="fa fa-camera fa-4x"></i>
                  </p>
                  <h4 class="text-center text-muted"> {{ 'Passport Copy' | translate }}
                    <small uib-tooltip="For New Arrivals">
                      <i class="fa fa-info-circle"></i>
                    </small>
                    <br>
                    <small>({{ 'Scan Copy' | translate}} )</small>
                  </h4>

                  <div style="position:relative;">
                    <a class="btn btn-block" href='javascript:;'>
                      <b style="color:whitesmoke;font-weight: 100;">{{ 'Choose File'| translate}}...</b>
                      <input class="choosefile" type="file" (change)="OnSelectPassportCopy($event,passObj)" size="10" accept="image/*" />
                    </a>
                    <img *ngIf="passObj.PassportCopy!=null" class="img-thumbnail imgdisplay" src="{{'data:image/jpg;base64,' + passObj.PassportCopy}}" height="75px">

                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Attachments End -->



          <div class="row checkAccept">
            <div class="col-lg-12">
              <!-- <label class="AdditionalDrivers"> -->
              <input type="checkbox" id="Chkterms" name="Chkterms" class="agreeTerms AgreeCheckBox" [(ngModel)]="agreeKYC" style=" zoom: 1.5;" />
              <span class="kycdeclare">{{'I here by declare the KYC details are correct' | translate}}
                <a style="color: green; text-decoration: underline;font-size: 12px;" onMouseOver="this.style.color='maroon'" onMouseOut="this.style.color='green'" data-toggle="modal" data-target="#ViewKYCDetails">{{'View KYC Details'| translate}}</a>
              </span>
              <!-- </label> -->
            </div>
          </div>
          <div class="row checkAccept">
            <div class="col-lg-9">
              <input type="checkbox" id="Chkterms" name="Chkterms" class="agreeTerms agreecheckboxtravel" [(ngModel)]="agreeTerms" style=" zoom: 1.5;" />
              <a href="{{this.url.DocumentURL}}Downloads/termsandcondition.pdf" style="font-weight:bold;" target="_blank" download>{{'I Agree to Policy Terms and Conditions' | translate}}</a>
            </div>
          </div>

          <div class="row acceptchck">
            <div class="col-lg-9">
              <input type="checkbox" id="Chkterms" name="Chkterms" class="agreeTerms medmalagreeterms" [(ngModel)]="agreeNatAdd" style=" zoom: 1.5;" />
              <a data-toggle="modal" data-target="#myModal" style="font-weight:bold;" target='_blank' download>{{'I Agree to National Address Declaration'| translate}}</a>
            </div>
          </div>



          <div id="myModal" class="modal fade">
            <div class="modal-dialog">
              <div class="modal-content" style="top: 300px;">
                <div class="modal-header" style="background-color: #004085;">
                  <button type="button" class="close" data-dismiss="modal">X</button>
                  <h4 class="modal-title logins" style="color: white;font-size: 14px !important;">
                    {{'National Address Declaration' | translate }}
                  </h4>
                </div>
                <div class="modal-body">
                  <p class="NatDecAr">{{'National Address Declaration Text' | translate }}
                  </p>
                </div>
              </div>
            </div>
          </div>

        </form>
        <br />
        <hr class="hr" style="margin-bottom:30px" />
        <div class="ButtonActions ">
          <div class="btn-group">
            <!-- <button class="btn btn-primary" name="btnPrev" id="btnPrev" (click)="GoPrev()">{{'Prev'| translate }}</button> -->
            <button class="btn btn-primary btnNext" name="btnNext" id="btnNext" [disabled]="!agreeTerms || !agreeKYC" (click)="GoNext(insuredForm.valid)">{{'Next'| translate }}</button>
          </div>
        </div>

        <div class="clears">

        </div>

      </div>


    </div>

  </div>

</div>




<div class="modal fade" id="HigherPosition" data-backdrop="static" role="dialog">
  <div class="modal-dialog modal-lg">
    <div class="modal-content" style="margin-bottom: 30px !important;overflow: scroll;height: 500px;">
      <div class="modal-header" style="background-color: #004085;">
        <button type="button" style="opacity:1;color:white;" class="close" data-dismiss="modal" #closeBtn>X</button>
        <h4 class="modal-title" style="color: white;font-size: 14px !important;">
          {{'Higher Position' | translate }}</h4>
      </div>
      <div class="modal-body">
        <table class="table table-bordered table-hover">
          <thead class="tablehead">
            <tr>
              <td>{{'Position' | translate}}</td>
              <td>{{'Nature of work' | translate}}</td>
              <td>{{'Grade/Field' | translate}}</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{'Prince'| translate}}</td>
              <td>
                <ul>
                  <li>{{'Political' | translate}}</li>
                  <li>{{'Business' | translate}}</li>
                </ul>
              </td>
              <td>
                <ul>
                  <li>{{'Royal Highness' | translate}}</li>
                  <li>{{'All kinds of Business' | translate}}</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>{{'Minister' | translate}}</td>
              <td>
                <ul>
                  <li>{{'Governmental Employees' | translate}}</li>
                </ul>
              </td>
              <td>
                <ul>
                  <li>{{'Grade 15+( High Grades)' | translate}}</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>{{'Officer' | translate}}</td>
              <td>
                <ul>
                  <li>{{'Police' | translate}}</li>
                  <li>{{'Army' | translate}}</li>
                </ul>
              </td>
              <td>
                <ul>
                  <li>{{'Colonel +' | translate}}</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>{{'Diplomatic Representative' | translate}}</td>
              <td>
                <ul>
                  <li>{{'Citizen' | translate}}</li>
                  <li>{{'Foreign' | translate}}</li>
                </ul>
              </td>
              <td>
                <ul>
                  <li>{{'Ambassador' | translate}}</li>
                  <li>{{'Consul' | translate}}</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>{{'Business Owner' | translate}}</td>
              <td>
                <ul>
                  <li>{{'Citizen' | translate}}</li>
                  <li>{{'Foreign' | translate}}</li>
                </ul>
              </td>
              <td>
                <ul>
                  <li>{{'Real Estate' | translate}}</li>
                  <li>{{'Gold ' | translate}}</li>
                </ul>
              </td>
            </tr>

          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>



<div class="modal fade" id="ViewKYCDetails" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="modal-title logins">{{'KYC Details'| translate}}</h4>
      </div>
      <div class="modal-body">
        <div class="kyccard">
          <div class="kyccard-header">
            <p class="kyccard-heading">{{'Insured Info' | translate}}</p>
          </div>
          <div class="kyccard-body">
            <div class="row cardsrow">
              <div class="kycinnercard col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="kycrow">
                  <span class="kyclabeldata">{{'Insured Name' | translate}}: </span>
                  <span class="kyclabelvalue">{{prObj.Insured_Name}}</span>
                </div>
                <div class="kycrow">
                  <span class="kyclabeldata">{{'ID Number' | translate}}: </span>
                  <span class="kyclabelvalue">{{prObj.Insured_IDNo}}</span>
                </div>
                <div class="kycrow">
                  <span class="kyclabeldata">{{'Mobile' | translate}}: </span>
                  <span class="kyclabelvalue">{{prObj.IMobileNo}}</span>
                </div>
                <div class="kycrow">
                  <span class="kyclabeldata">{{'Email Id' | translate}}: </span>
                  <span class="kyclabelvalue">{{prObj.Insured_EmailId}}</span>
                </div>
                <div class="kycrow">
                  <span class="kyclabeldata">{{'ID Expiry' | translate}}:</span>
                  <span class="kyclabelvalue">{{prObj.IDExpiry}}</span>
                </div>
                <div class="kycrow">
                  <span class="kyclabeldata">{{'Additional Code' | translate}}:</span>
                  <span class="kyclabelvalue">{{prObj.Insured_AdditionalCode}}</span>
                </div>
              </div>
              <div class="kycinnercard col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="kycrow">
                  <span class="kyclabeldata">{{'City' | translate}}: </span>
                  <span class="kyclabelvalue">{{CityName}}</span>
                </div>
                <div class="kycrow">
                  <span class="kyclabeldata">{{'Area Name' | translate}}: </span>
                  <span class="kyclabelvalue">{{prObj.Insured_AreaName}}</span>
                </div>
                <div class="kycrow">
                  <span class="kyclabeldata">{{'Street Name' | translate}}: </span>
                  <span class="kyclabelvalue">{{prObj.Insured_StreetName}}</span>
                </div>
                <div class="kycrow">
                  <span class="kyclabeldata">{{'Building No' | translate}}: </span>
                  <span class="kyclabelvalue">{{prObj.Insured_BuildingNo}}</span>
                </div>
                <div class="kycrow">
                  <span class="kyclabeldata">{{'Unit No' | translate}}:</span>
                  <span class="kyclabelvalue">{{prObj.Insured_UnitNo?prObj.Insured_UnitNo:0}}</span>
                </div>
                <div class="kycrow">
                  <span class="kyclabeldata">{{'Postal Code' | translate}}:</span>
                  <span class="kyclabelvalue">{{prObj.Insured_POPostalCode}}</span>
                </div>
              </div>
            </div>
            <!-- <hr class="lineclass"> -->
            <div class="row" style="margin:10px;">
              <div class="col-lg-3 col-md-3 col-sm-4 col-xs-5 kyclabelrow">
                <label class="kyclabel">{{'American Citizen?' | translate }} </label>
                <label class="kyclabel kycvalue">
                  <label *ngIf="this.prObj.Insured_Nationality=='17'">{{'Yes' | translate }}</label>
                  <label *ngIf="this.prObj.Insured_Nationality!='17'">{{ 'No' | translate }}</label>
                </label>
              </div>
              <div class="col-lg-4 col-md-5 col-sm-8 col-xs-7 kyclabelrow">
                <label class="kyclabel">{{'If yes, American ID No' | translate }}: </label>
                <label class="kyclabel kycvalue">{{prObj.AmericanID}}</label>
              </div>
            </div>
            <div class="row" style="margin:10px;">
              <div class="col-lg-3 col-md-3 col-sm-4 col-xs-6 kyclabelrow">
                <label class="kyclabel">{{'Political Person? ' | translate }} </label>
                <label class="kyclabel kycvalue">
                  <label *ngIf="prObj.IsHigherPosition">{{'Yes' | translate }}</label>
                  <label *ngIf="!prObj.IsHigherPosition">{{ 'No' | translate }}</label>
                </label>
              </div>
              <div class="col-lg-6 col-md-7 col-sm-8 col-xs-12 kyclabelrow">
                <label class="kyclabel">{{'If yes, Please specify job title and rank' | translate }}:
                </label>
                <label class="kyclabel kycvalue" *ngIf="this.prObj.HigherPositionCode==1">{{'Prince' | translate}}</label>
                <label class="kyclabel kycvalue" *ngIf="this.prObj.HigherPositionCode==2">{{'Minister' | translate}}</label>
                <label class="kyclabel kycvalue" *ngIf="this.prObj.HigherPositionCode==3">{{'Officer' | translate}}</label>
                <label class="kyclabel kycvalue" *ngIf="this.prObj.HigherPositionCode==4">{{'Diplomatic Representative' | translate}}</label>
                <label class="kyclabel kycvalue" *ngIf="this.prObj.HigherPositionCode==5">{{'Business Owner' | translate}}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/TravelPortal/TravelBasicInfo/TravelBasicInfo.html